import React, { useState, useEffect, useRef } from "react";
import styles from "./style.module.css";

interface Props {
  ref?: React.RefObject<HTMLInputElement>;
  width?: string | number;
  height?: string | number;
  bold?: boolean;
  bottomContents?: React.ReactNode;
  fontSize?: number;
  style?: React.CSSProperties;
  limit?: number;
  clear?: () => void;
  inputStyle?: React.CSSProperties;
  onChange: (item: string) => void;
  value?: string;
  placeholder?: string;
  containerClassName?: string;
  inputClassName?: string;
  type?: React.HTMLInputTypeAttribute;
  onBlur?: () => void;
  readOnly?: boolean;
  secondline?: boolean;
}

export default function Input({
  ref,
  width = "100%",
  height = 40,
  bold,
  style,
  bottomContents,
  limit,
  fontSize,
  clear,
  value,
  inputStyle,
  onChange,
  placeholder,
  containerClassName = "",
  inputClassName = "",
  type = "text",
  onBlur,
  readOnly = false,
  secondline = true,
}: Props) {
  const [isFocus, setIsFocus] = useState(false);
  const [textLength, setTextLength] = useState(0);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!value || value.length === 0) {
      setTextLength(0);
    }
  }, [value]);

  return (
    <div
      style={{
        width,
        ...style,
        ...(!secondline
          ? {
              display: "flex",
              justifyContent: "space-between",
            }
          : {
              position: "relative",
            }),
      }}
      className={containerClassName}
    >
      <div style={{ justifyContent: "center", width }}>
        <input
          className={[styles.input, inputClassName].join(" ")}
          ref={inputRef}
          type={type}
          readOnly={readOnly}
          onClick={(e) => e.stopPropagation()}
          onFocus={() => setIsFocus(true)}
          onBlur={() => {
            setIsFocus(false);
            onBlur?.();
          }}
          style={{
            borderWidth: "1px",
            borderColor: "gray",
            borderRadius: "4px",
            paddingLeft: "8px",
            paddingRight: "8px",
            color: "black",
            width,
            height,
            fontSize,
            fontFamily: bold ? "SUIT-Bold" : "SUIT-Regular",
            ...(isFocus && {
              borderColor: "mainColor",
              borderWidth: "2px",
            }),
            ...inputStyle,
          }}
          maxLength={limit}
          value={value}
          onChange={(e) => {
            onChange && onChange(e.target.value);
            setTextLength(e.target.value.length);
          }}
          placeholder={placeholder}
        />
        {!!secondline && !!clear && (
          <button
            onClick={clear}
            style={{
              position: "absolute",
              top: -7,
              right: -5,
              width: "44px",
              height: "44px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src="/images/xCircle.png" alt="Clear" />
          </button>
        )}
      </div>
      {!secondline && !!clear && (
        <button
          onClick={clear}
          style={{
            width: "44px",
            height: "44px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src="/images/xCircle.png" alt="Clear" />
        </button>
      )}
      {(bottomContents || limit) && (
        <div
          style={{
            display: "flex",
            ...(!secondline
              ? {
                  alignItems: "center",
                  justifyContent: "center",
                }
              : {
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "4px",
                  paddingLeft: "8px",
                  marginBottom: "8px",
                }),
          }}
        >
          {typeof bottomContents === "string" ? (
            <p style={{ color: "gray" }}>{bottomContents}</p>
          ) : (
            bottomContents || <div />
          )}
          <p style={{ color: "gray" }}>
            {limit ? `${textLength}/${limit}` : ""}
          </p>
        </div>
      )}
    </div>
  );
}
